// extracted by mini-css-extract-plugin
module.exports = {"input-range":"styles_input-range__PQff2","input-range__input":"styles_input-range__input__2BkwQ","input-range__label":"styles_input-range__label__sLWqR"};